import classnames from 'classnames';
import {defineMessages, injectIntl} from 'react-intl';
import formatUtil from 'universally-shared-code/util/formatUtil';
import moment from 'moment';
import React from 'react';

import Download from '../icons/Download';
import Duration from '../general/Duration';
import InfinityIcon from '../icons/InfinityIcon';
import Size from '../general/Size';
import Upload from '../icons/Upload';

const messages = defineMessages({
  ago: {
    id: 'general.ago',
    defaultMessage: 'ago'
  }
});

const icons = {
  download: <Download />,
  infinity: <InfinityIcon />,
  upload: <Upload />
};

class TransferRateDetails extends React.Component {
  constructor() {
    super();

    this.state = {inspectorPoint: null};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.inspectorPoint != null) {
      this.setState({timestamp: nextProps.inspectorPoint.nearestTimestamp});
    }
  }

  getCurrentTansferRate(slug, options = {}) {
    let {
      props: {
        inspectorPoint,
        transferSummary
      }
    } = this;

    const throttles = {
      download: transferSummary.downThrottle,
      upload: transferSummary.upThrottle
    };
    let timestamp = null;
    let transferRates = {
      download: transferSummary.downRate,
      upload: transferSummary.upRate
    };
    let transferTotals = {
      download: transferSummary.downTotal,
      upload: transferSummary.upTotal
    };

    const secondaryDataClasses = classnames(
      'client-stats__rate__data--secondary',
      {'is-visible': inspectorPoint == null}
    );

    const timestampClasses = classnames(
      'client-stats__rate__data--timestamp',
      {'is-visible': inspectorPoint != null && options.showHoverDuration}
    );

    if (inspectorPoint != null) {
      transferRates = {
        upload: inspectorPoint.uploadSpeed,
        download: inspectorPoint.downloadSpeed
      };
    }

    if (this.state.timestamp != null) {
      const currentTime = moment(Date.now());
      const durationSummary = formatUtil.secondsToDuration(
        moment
          .duration(currentTime.diff(moment(this.state.timestamp)))
          .asSeconds()
      );

      timestamp = (
        <div className={timestampClasses}>
          <Duration
            suffix={this.props.intl.formatMessage(messages.ago)}
            value={durationSummary} />
        </div>
      );
    }

    let limit = null;

    if (throttles[slug] === 0) {
      limit = icons.infinity;
    } else {
      limit = <Size value={throttles[slug]} isSpeed={true} />;
    }

    return (
      <div className={`client-stats__rate client-stats__rate--${slug}`}>
        <div className="client-stats__rate__icon">
          {icons[slug]}
        </div>
        <div className="client-stats__rate__data">
          <div className="client-stats__rate__data--primary">
            <Size value={transferRates[slug]} isSpeed={true} />
          </div>
          {timestamp}
          <div className={secondaryDataClasses}>
            <div className="client-stats__rate__data--total">
              <Size value={transferTotals[slug]} />
            </div>
            <div className="client-stats__rate__data--limit">
              {limit}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="client-stats__rates">
        {this.getCurrentTansferRate('download', {showHoverDuration: true})}
        {this.getCurrentTansferRate('upload')}
      </div>
    );
  }
}

export default injectIntl(TransferRateDetails);



// WEBPACK FOOTER //
// ./client/src/javascript/components/sidebar/TransferRateDetails.js